module.exports = __webpack_public_path__ + "static/media/tock.ba42be0.wav";


//////////////////
// WEBPACK FOOTER
// ./static/music/tock.wav
// module id = r23h
// module chunks = 1